import { MouseEventHandler } from 'react'

import { Text } from '@hhgtech/hhg-components/components'
import { theme } from '@hhgtech/hhg-components/misc'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { useIntl } from 'react-intl'

import { StyledReadMoreButton } from './index.styled'

export const ReadMoreButton = ({
  onClick,
}: {
  onClick?: MouseEventHandler<HTMLDivElement>
}) => {
  const { formatMessage: f } = useIntl()
  const currentUrl = useCurrentUrl()
  return (
    <StyledReadMoreButton
      onClick={onClick}
      data-event-category="Continue Reading"
      data-event-action="Click"
      data-event-label={currentUrl}
    >
      <button className="content">
        <span className="arrow">
          <span />
        </span>
        <Text size="s3" color={theme.colors.primaryBase} type="semiBold">
          {f({
            id: 'continueReading',
            defaultMessage: 'Continue Reading',
          })}
        </Text>
      </button>
    </StyledReadMoreButton>
  )
}
